// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZQOa","content":"styles_content__cV19-","tableWrap":"styles_tableWrap__pMrNt"};